module.exports = __webpack_public_path__ + "static/media/BlueDark_SagaLogo.31b34024.png";